import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiPreconditionRequiredError extends TmApiClientError {
  public name = 'TmApiPreconditionRequiredError'

  protected override code: TmTransportHttpErrorCode = 428
}
